module.exports = __webpack_public_path__ + "static/google-play-badge-e6fad9711e0a713f86ee348082cce087.png";